// Shared debounce window for IR Workstation search inputs, so every search
// field waits the same amount of time after the last keystroke before hitting
// the API (CR-1734). Raised from 200/300ms to keep request volume — and the
// logs — down without making the fields feel sluggish.
export const SEARCH_DEBOUNCE_MS = 300;
